export default build =>
    build.mutation({
        query(payload) {         
            return {
                url: '/photogallery/updateEventName',
                method: 'POST',
                body: payload,
            };
        },
        invalidatesTags: ['eventByYear'],
       
    })
